import Router from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

import NotFound from '@/containers/NotFound'
import DefaultContainer from '@/containers/DefaultContainer'
import Login from '@/components/Login'
import Implementation from '@/components/Implementation'
import Signed from '@/components/Signed'
import Exit from '@/components/Exit'
import OidcCallback from '@/components/OidcCallback'
import Loading from '@/components/Loading'
import NotEligible from '@/components/NotEligible'
import Eligibility from '@/components/Eligibility'
import SilentRenew from "@/components/SilentRenew";


const router = new Router({
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: [
    {
      path: '/404',
      name: 'notfound',
      component: NotFound
    },

    {
      path: '/login/:id',
      name: 'login',
      component: Login
    },

    {
      path: '/loading/:id',
      name: 'login',
      component: Loading
    },

    {
      path: '/confirm-login',
      name: 'OidcCallback',
      component: OidcCallback
    },

    {
      path: '/silent-renew',
      name: 'SilentRenew',
      component: SilentRenew
    },

    {
      path: '/confirm-logout',
      name: 'OidcCallback',
      component: OidcCallback
    },

    {
      path: '/fa',
      component: DefaultContainer,
      children: [
        {
          path: 'eligibility',
          name: 'eligibility',
          component: Eligibility,
        },
        {
          path: 'agreement',
          name: 'implementation',
          component: Implementation
        },
        {
          path: '/signed',
          name: 'signed',
          component: Signed
        },

        {
          path: 'not-eligible',
          name: 'not-eligible',
          component: NotEligible
        },

        {
          path: '/exit',
          name: 'exit',
          component: Exit
        }
      ]

    }
  ]
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store,'oidc'))
export default router
